// Color names choosen by http://chir.ag/projects/name-that-color
import {
  __colors as _linbColors,
  colors as baseColors,
} from '../constants/colors';

/**
 * @deprecated use `@/theme` instead
 */
export const colors = {
  ...baseColors,
  mirage: 'mirage',
  unset: 'unset',
  transparent: 'tranparent',
  portage: 'portage',
  santasGray: 'santasGray',
  daisyBush: 'daisyBush',
  shark: 'shark',
  purpleHeart: 'purpleHeart',
  orangePeel: 'orangePeel',
  selago: 'selago',
  woodSmoke: 'woodSmoke',
  balticSea: 'balticSea',
  mulledWine: 'mulledWine',
  chestnutRose: 'chestnutRose',
  sunglow: 'sunglow',
  fern: 'fern',
  cornflowerBlue: 'cornflowerBlue',
  studio: 'studio',
  portGore: 'portGore',
  riverBed: 'riverBed',
  haiti: 'haiti',
  meteorite: 'meteorite',
  eerieBlack: 'eerieBlack',
  copperRed: 'copperRed',
  russianViolet: 'russianViolet',
  lavenderBlue: 'lavenderBlue',
  blueViolet: 'blueViolet',
  spanishViolet: 'spanishViolet',
  fuchsiaBlue: 'fuchsiaBlue',
  steelGray: 'steelGray',
  slateBlue: 'slateBlue',
  dullLavender: 'dullLavender',
  royalBlue: 'royalBlue',
  canary: 'canary',
  dodgerBlue: 'dodgerBlue',
  bitterSweet: 'bitterSweet',
  cerise: 'cerise',
  oliveDrab: 'oliveDrab',
  curiousBlue: 'curiousBlue',
  macaroniAndCheese: 'macaroniAndCheese',
  electricViolet: 'electricViolet',
  mintGreen: 'mintGreen',
  brightTurquoise: 'brightTurquoise',
  jungleGreen: 'jungleGreen',
  blueberry: 'blueberry',
  texasRose: 'texasRose',
  crusta: 'crusta',
  lipstick: 'lipstick',
  chineseSilver: 'chineseSilver',
  brightLavender: 'brightLavender',
  codGray: 'codGray',
  emperor: 'emperor',
  japaneseIndigo: 'japaneseIndigo',
  dodgeBlue: 'dodgeBlue',
  deepSaffron: 'deepSaffron',
  redRyb: 'redRyb',
  brownCoffee: 'brownCoffee',
  emarald: 'emarald',
  darkJungelGreen: 'darkJungelGreen',
  bistre: 'bistre',
  spanishGray: 'spanishGray',
} as const;

export const __colors = {
  ..._linbColors,
  [colors.unset]: 'unset',
  [colors.transparent]: '#00000000',
  [colors.mirage]: '#151A24',
  [colors.portage]: '#9077F6',
  [colors.santasGray]: '#A09FAF',
  [colors.daisyBush]: '#3F2B95',
  [colors.shark]: '#1F2025',
  [colors.purpleHeart]: '#5F41D9',
  [colors.orangePeel]: '#FF9800',
  [colors.selago]: '#E9E4FD',
  [colors.woodSmoke]: '#0D0D0F',
  [colors.balticSea]: '#24222C',
  [colors.mulledWine]: '#413E60',
  [colors.chestnutRose]: '#D24E4E',
  [colors.sunglow]: '#FFBA33',
  [colors.fern]: '#60BF80',
  [colors.cornflowerBlue]: '#7E60FA',
  [colors.studio]: '#5843AF',
  [colors.portGore]: '#261D4B',
  [colors.riverBed]: '#434D61',
  [colors.haiti]: '#1C1341',
  [colors.meteorite]: '#392782',
  [colors.eerieBlack]: '#1E1E20',
  [colors.copperRed]: '#D07752',
  [colors.russianViolet]: '#201256',
  [colors.lavenderBlue]: '#D3C9FC',
  [colors.blueViolet]: '#735FC5',
  [colors.spanishViolet]: '#3F307D',
  [colors.fuchsiaBlue]: '#6F5AC2',
  [colors.steelGray]: '#282536',
  [colors.slateBlue]: '#6F5AC2',
  [colors.dullLavender]: '#9A8DE7',
  [colors.royalBlue]: '#6947F2',
  [colors.canary]: '#E9FF62',
  [colors.dodgerBlue]: '#5379FF',
  [colors.bitterSweet]: '#FF6A6A',
  [colors.cerise]: '#D74192',
  [colors.oliveDrab]: '#7DA725',
  [colors.curiousBlue]: '#18A1C9',
  [colors.macaroniAndCheese]: '#FFBA88',
  [colors.electricViolet]: '#B132FF',
  [colors.blueberry]: '#497CFF',
  [colors.mintGreen]: '#8FFD85',
  [colors.brightTurquoise]: '#33D8FC',
  [colors.jungleGreen]: '#2EBA5D',
  [colors.texasRose]: '#FFC34E',
  [colors.crusta]: '#FA8C3C',
  [colors.lipstick]: '#C5005F',
  [colors.chineseSilver]: '#CCCCCC',
  [colors.brightLavender]: '#A692F8',
  [colors.codGray]: '#1D1D1D',
  [colors.emperor]: '#555555',
  [colors.japaneseIndigo]: '#1E3951',
  [colors.dodgeBlue]: '#189EFF',
  [colors.deepSaffron]: '#FE9B28',
  [colors.redRyb]: '#F52C11',
  [colors.brownCoffee]: '#4A2221',
  [colors.emarald]: '#53B964',
  [colors.darkJungelGreen]: '#1B2F20',
  [colors.bistre]: '#3D2914',
  [colors.spanishGray]: '#999999',
};

export type ColorType = keyof typeof colors | keyof typeof _linbColors;

export const hexToRGB = hex =>
  hex
    .substr(1)
    .match(/.{1,2}/g)
    .map(c => parseInt(c, 16));

export const hexToRGBA = (hex: string, alpha?: number) =>
  `rgba(${hexToRGB(hex)}, ${alpha})`;

/**
 * @deprecated use `@/theme` instead
 */
export const getColor = (_color: ColorType = colors.shark, alpha?: number) => {
  const color = __colors[_color] ?? _color;
  if (!color) {
    throw new Error(`color ${_color} does not match`);
  }
  return alpha ? hexToRGBA(color, alpha) : color;
};
